'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'wand-magic-sparkles';
var width = 640;
var height = 512;
var aliases = ["magic-wand-sparkles"];
var unicode = 'e2ca';
var svgPathData = 'M288 112l-24-56-56-24 56-24 24-56 24 56 56 24-56 24-24 56zM16 128l80-32 32-80 32 80 80 32-80 32-32 80-32-80-80-32zM464 368l32-80 32 80 80 32-80 32-32 80-32-80-80-32 80-32zM496-13.3L589.3 80 471.6 197.7 378.3 104.4 496-13.3zM50.7 432L344.4 138.3 437.7 231.6 144 525.3 50.7 432z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faWandMagicSparkles = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;